import { Record, List } from 'immutable';
import { construct, fields, resolve, resolveAll } from '../helpers/LinkMapper';
import ReservationLeg from './ReservationLeg';
import ReservationStation from './ReservationStation';
import trainTime from '../lib/TrainTime';

const ReservationJourney = new Record({
    id: null,
    origin: new ReservationStation(),
    destination: new ReservationStation(),
    ticketType: null,
    routeCode: null,
    type: null,
    legs: new List(),
});

Object.assign(ReservationJourney.prototype, {
    getFirstLeg() {
        const legs = this.get('legs');
        return legs && legs.size > 0 ? legs.first() : null;
    },

    getLastLeg() {
        const legs = this.get('legs');
        return legs && legs.size > 0 ? legs.last() : null;
    },

    isDirect() {
        const legs = this.get('legs');
        return legs && legs.size === 1;
    },

    getDepartureTime() {
        const leg = this.getFirstLeg();
        if (leg && leg.departure) {
            return trainTime(leg.departure).format('HH:mm');
        }
        return null;
    },

    getArrivalTime() {
        const leg = this.getFirstLeg();
        if (leg && leg.arrival) {
            return trainTime(leg.arrival).format('HH:mm');
        }
        return null;
    },

    getOriginName() {
        const leg = this.getFirstLeg();
        return leg && leg.origin && leg.origin.name ? leg.origin.name : '';
    },

    getDestinationName() {
        const leg = this.getLastLeg();
        return leg && leg.destination && leg.destination.name ? leg.destination.name : '';
    },
});

ReservationJourney.fromJSON = function(json) {
    return construct(ReservationJourney, json, {
        id: fields.string,
        origin: resolve.as(ReservationStation),
        destination: resolve.as(ReservationStation),
        ticketType: fields.string,
        routeCode: fields.string,
        type: fields.string,
        legs: resolveAll.as(ReservationLeg),
    });
};

export default ReservationJourney;
